"use strict";

var _interopRequireDefault = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.split");
var _regenerator2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _objectSpread2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _broker = require("@/api/broker");
var _operation = require("@/api/operation");
var _vuex = require("vuex");
var url = window.location.host;
var getDefaultFormData = function getDefaultFormData() {
  return {
    country_code: 'CN',
    lement_type: 1,
    is_modification_proportion: 0,
    society_proportion: 55,
    anchor_proportion: 50,
    broker_model: 1,
    anchor_unit_price: 45,
    area_code: []
  };
};
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default
  },
  directives: {
    waves: _waves.default
  },
  filters: {
    statusFilter: function statusFilter(val) {
      return val === 1 ? '正常' : '停用';
    },
    proportionFilter: function proportionFilter(val) {
      return val === 0 ? '关闭' : '开启';
    },
    brokerModelFilter: function brokerModelFilter(val) {
      return val === 1 ? '独立' : '推广';
    }
  },
  data: function data() {
    var _this = this;
    var required = function required(label) {
      return function (rule, value, callback) {
        if (value === undefined || value === null || value === '' || Array.isArray(value) && value.length === 0) {
          callback(new Error(_this.$t('form.pleaseEnter') + label));
        } else {
          callback();
        }
      };
    };
    var requiredWhenCredentialVisible = function requiredWhenCredentialVisible(label) {
      return function (rule, value, callback) {
        if (_this.showCredentialFields && (value === undefined || value === null || value === '')) {
          callback(new Error(_this.$t('form.pleaseEnter') + label));
        } else {
          callback();
        }
      };
    };
    return {
      science: url === process.env.VUE_APP_URL_ADMIN_HOST ? 'overseas' : 'china',
      listLoading: false,
      lementList: [{
        label: '公对私',
        value: 1
      }, {
        label: '公对公',
        value: 2
      }],
      proportionList: [{
        label: '关闭',
        value: 0
      }, {
        label: '开启',
        value: 1
      }],
      list: [],
      total: 0,
      listQuery: {
        page: 1,
        size: 10,
        startTime: '',
        endTime: '',
        area_code: '',
        city_name: '',
        country_code: '',
        status: '',
        brokerId: '',
        authCode: '',
        name: '',
        bd_id: ''
      },
      times: [],
      areaCodeList: [],
      formData: getDefaultFormData(),
      rules: {
        name: {
          validator: required(this.$t('table.name')),
          trigger: 'blur'
        },
        phone_number: {
          validator: required(this.$t('table.mobile')),
          trigger: 'blur'
        },
        area_code: {
          validator: required('管辖区域'),
          trigger: 'change'
        },
        city_name: {
          validator: required(this.$t('table.city')),
          trigger: 'blur'
        },
        country_code: {
          validator: required(this.$t('table.countryCode')),
          trigger: 'blur'
        },
        broker_username: {
          validator: requiredWhenCredentialVisible(this.$t('table.loginID')),
          trigger: 'blur'
        },
        broker_psg: {
          validator: requiredWhenCredentialVisible(this.$t('table.password')),
          trigger: 'blur'
        },
        auth_code: {
          validator: requiredWhenCredentialVisible(this.$t('table.invitationCode')),
          trigger: 'blur'
        },
        broker_model: {
          validator: required(this.$t('table.brokerModel')),
          trigger: 'blur'
        }
      },
      dialogVisible: false,
      dialogType: 'new',
      detailVisible: false,
      detailBroker: {}
    };
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['roles'])), {}, {
    isBdRole: function isBdRole() {
      return this.roles.includes('bd');
    },
    isAdminRole: function isAdminRole() {
      return ['development', 'superAdmin', 'operation', 'product'].includes(this.roles[0]);
    },
    canEditBroker: function canEditBroker() {
      return this.isAdminRole || this.isBdRole;
    },
    showCredentialFields: function showCredentialFields() {
      return !this.isBdRole || this.dialogType === 'new';
    }
  }),
  watch: {
    times: function times(val) {
      this.listQuery.startTime = '';
      this.listQuery.endTime = '';
      if (val) {
        this.listQuery.startTime = val[0];
        this.listQuery.endTime = val[1];
      }
    }
  },
  mounted: function mounted() {
    this.getList();
    this.getAreaList();
  },
  methods: {
    getList: function () {
      var _getList = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var _yield$borkerList, code, data;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.listLoading = true;
              _context.n = 1;
              return (0, _broker.borkerList)(this.listQuery);
            case 1:
              _yield$borkerList = _context.v;
              code = _yield$borkerList.code;
              data = _yield$borkerList.data;
              this.listLoading = false;
              if (code === 0) {
                this.list = data.list;
                this.total = data.total;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }(),
    getAreaList: function () {
      var _getAreaList = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var _yield$areaList, code, data;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return (0, _operation.areaList)();
            case 1:
              _yield$areaList = _context2.v;
              code = _yield$areaList.code;
              data = _yield$areaList.data;
              if (code === 0) {
                this.areaCodeList = data;
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function getAreaList() {
        return _getAreaList.apply(this, arguments);
      }
      return getAreaList;
    }(),
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    goAnchorData: function goAnchorData(row) {
      this.$router.push({
        path: this.isBdRole ? '/bdManage/income' : '/brokerManage/income',
        query: {
          brokerId: row.broker_id
        }
      });
    },
    goGuildData: function goGuildData(row) {
      this.$router.push({
        path: this.isBdRole ? '/bdManage/guildData' : '/brokerManage/settlement',
        query: {
          brokerId: row.broker_id
        }
      });
    },
    handleDetail: function handleDetail(row) {
      this.detailBroker = JSON.parse(JSON.stringify(row));
      this.detailVisible = true;
    },
    handleEdit: function handleEdit(row) {
      var _this2 = this;
      if (row) {
        this.dialogType = 'edit';
        this.formData = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, getDefaultFormData()), JSON.parse(JSON.stringify(row)));
        this.formData.anchor_unit_price = this.formData.anchor_unit_price ? this.formData.anchor_unit_price / 100 : '';
        this.formData.area_code = this.formData.area_code ? String(this.formData.area_code).split(',').filter(Boolean) : [];
      } else {
        this.dialogType = 'new';
        this.formData = getDefaultFormData();
      }
      this.dialogVisible = true;
      this.$nextTick(function () {
        return _this2.$refs.editForm.clearValidate();
      });
    },
    confirm: function () {
      var _confirm = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4() {
        var _this3 = this;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              this.$refs.editForm.validate(/*#__PURE__*/function () {
                var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3(valid) {
                  var area_code, _yield$editBroker, code, message;
                  return (0, _regenerator2.default)().w(function (_context3) {
                    while (1) switch (_context3.n) {
                      case 0:
                        if (valid) {
                          _context3.n = 1;
                          break;
                        }
                        return _context3.a(2, false);
                      case 1:
                        area_code = Array.isArray(_this3.formData.area_code) ? _this3.formData.area_code.join(',') : _this3.formData.area_code;
                        _context3.n = 2;
                        return (0, _broker.editBroker)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, _this3.formData), {}, {
                          type: _this3.dialogType,
                          area_code: area_code
                        }));
                      case 2:
                        _yield$editBroker = _context3.v;
                        code = _yield$editBroker.code;
                        message = _yield$editBroker.message;
                        if (code === 0) {
                          _this3.$message({
                            message: _this3.dialogType === 'edit' ? _this3.$t('form.editSuccess') : _this3.$t('form.addSuccess'),
                            type: 'success'
                          });
                          _this3.dialogVisible = false;
                          _this3.getList();
                        }
                        if (code !== 0) {
                          _this3.$message({
                            message: message,
                            type: 'error'
                          });
                          _this3.dialogVisible = false;
                          _this3.getList();
                        }
                      case 3:
                        return _context3.a(2);
                    }
                  }, _callee3);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 1:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function confirm() {
        return _confirm.apply(this, arguments);
      }
      return confirm;
    }(),
    handleStatus: function handleStatus(row) {
      var _this4 = this;
      var info;
      if (url === process.env.VUE_APP_URL_ADMIN_HOST) {
        info = this.$t('form.deleteBrokerInfo');
      } else {
        info = '此操作将移除公会,并将旗下主播转为野生主播！';
      }
      this.$confirm(info, this.$t('tips.tips'), {
        confirmButtonText: this.$t('form.confirm'),
        cancelButtonText: this.$t('form.cancel'),
        type: 'warning'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee5() {
        var status, _yield$deleteBroker, code;
        return (0, _regenerator2.default)().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              status = row.STATUS === 1 ? 2 : 1;
              _context5.n = 1;
              return (0, _broker.deleteBroker)({
                broker_id: row.broker_id,
                status: status
              });
            case 1:
              _yield$deleteBroker = _context5.v;
              code = _yield$deleteBroker.code;
              if (code === 0) {
                _this4.$message({
                  message: _this4.$t('form.editSuccess'),
                  type: 'success'
                });
                _this4.getList();
              }
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      })));
    }
  }
};